/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        //Click btnToggleMenu
        $('#btn-toggleMenu').click(function (event) {
          event.preventDefault();
          $(this).next('nav.nav-primary').slideToggle(400);
        });


        //Click toggle menu item
        $('nav.nav-primary').find('li.menu-item-has-children').append('<i class="fa fa-angle-down" aria-hidden="true"></i>');

        $('li.menu-item-has-children .fa').click(function () {
          $(this).prev('ul.sub-menu').slideToggle(400);
        });

        //Click search btn
        $('.header-actions a.btn-search').click(function (event) {
          event.preventDefault();
          $('.header-actions').next('.search-form').fadeToggle();
        });

        $(window).scroll(function(){
          if ($(this).scrollTop() > 150) {
            if ($(window).width() > 992){
              $('#scrollToTop').fadeIn(400);
            }
            // $('div.sbzon, div.sbzoff').addClass('show-chat');
          } else {
            if ($(window).width() > 992){
              $('#scrollToTop').fadeOut(400);
            }
            // $('div.sbzon, div.sbzoff').removeClass('show-chat');
          }
        });

        //Scroll to top button clicked
        $('#scrollToTop').click(function(){
          $('html, body').animate({scrollTop : 0},800);
          return false;
        });

        var listPartners = $('ul#partners').lightSlider({
          item:7,
          loop:true,
          auto: true,
          pauseOnHover: true,
          slideMove:2,
          easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
          speed:600,
          pager: false,
          controls: false,
          responsive : [
            {
              breakpoint:768,
              settings: {
                item:4,
                slideMove:1
              }
            },
            {
              breakpoint:480,
              settings: {
                item:2,
                slideMove:1
              }
            }
          ]
        });

        $('#goToPrevSlide').click(function(event){
          event.preventDefault();
          listPartners.goToPrevSlide();
        });
        $('#goToNextSlide').click(function(event){
          event.preventDefault();
          listPartners.goToNextSlide();
        });

        $('.footer-widget .widget > h3').click(function () {
          $(this).next('div').slideToggle(400);
        });

        $('aside.sidebar .widget > h3').click(function () {
          if ($(this).hasClass('block-open')){
            $(this).removeClass('block-open');
            $(this).addClass('block-close');
          }else{
            $(this).removeClass('block-close');
            $(this).addClass('block-open');
          }
          $(this).next('div').slideToggle();
        });

        $('aside.sidebar ul.menu li.menu-item-has-children').append('<i class="fa fa-caret-down" aria-hidden="true"></i>');

        $('aside.sidebar ul.menu li.menu-item-has-children .fa').click(function () {
          if ($(this).hasClass('block-open')){
            $(this).removeClass('block-open');
            $(this).addClass('block-close');
          }else{
            $(this).removeClass('block-close');
            $(this).addClass('block-open');
          }
          $(this).prev('ul.sub-menu').slideToggle();
        });

      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
